<template>
  <div id="experience-landing">
    <AppHeader>{{ tag ? tag.label : 'Experience' }}</AppHeader>

    <div class="content-container experience-shell">
      <div class="content">
        <v-container>
          <v-btn
            outlined
            class="back-link mb-6"
            :to="{ name: 'reckon-way' }"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            The Reckon Way
          </v-btn>

          <section v-if="tag" class="experience-intro">
            <div class="kicker">{{ tag.category }}</div>
            <h1>{{ tag.label }}</h1>
            <p>
              Explore Reckon Way trips connected by this shared experience.
            </p>
            <TagPill
              :label="tag.label"
              :category="tag.category"
            />
          </section>

          <section v-if="tag && matchingTrips.length" class="experience-results">
            <h2 class="section-title">Trips With This Tag</h2>
            <v-row class="experience-grid">
              <v-col
                v-for="trip in matchingTrips"
                :key="trip.slug"
                cols="12"
                md="6"
                lg="4"
              >
                <TripCard
                  v-bind="tripCardForGallery(trip)"
                  :tags="trip.tags || []"
                  :to="{ name: 'reckon-way-gallery', params: { gallerySlug: trip.slug } }"
                  variant="featured"
                />
              </v-col>
            </v-row>
          </section>

          <section v-else-if="tag" class="empty-state">
            <h2>No Trips Yet</h2>
            <p>This tag is ready, but no Reckon Way trips are using it yet.</p>
          </section>

          <section v-else class="empty-state">
            <h2>Experience Not Found</h2>
            <p>That tag does not exist yet.</p>
          </section>
        </v-container>
      </div>
    </div>

    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue';
import AppHeader from '../components/Header.vue';
import TagPill from '../components/TagPill.vue';
import TripCard from '../components/TripCard.vue';
import { allAdventureGalleries } from '../data/adventureGalleries';
import { getTripTagDefinition, getTripsByTag } from '../data/reckonWayTags';

export default {
  name: 'ExperienceLandingView',
  components: {
    AppFooter,
    AppHeader,
    TagPill,
    TripCard,
  },
  computed: {
    tagSlug() {
      return this.$route.params.tagSlug;
    },
    tag() {
      return getTripTagDefinition(this.tagSlug);
    },
    matchingTrips() {
      return getTripsByTag(allAdventureGalleries, this.tagSlug);
    },
  },
  methods: {
    tripCardForGallery(gallery) {
      if (gallery.tripCard) {
        return gallery.tripCard;
      }

      const destination = gallery.destination
        ? [gallery.destination.city, gallery.destination.country].filter(Boolean).join(', ')
        : gallery.meta;

      return {
        tripSlug: gallery.slug,
        title: gallery.title,
        subtitle: gallery.subtitle || '',
        destination,
        date: gallery.dateLabel || '',
        tripType: gallery.tripType || gallery.meta,
        heroImage: gallery.heroImage,
        heroAspectRatio: gallery.heroAspectRatio || 1.5,
        containImage: gallery.containHero === true,
        summary: gallery.summary || gallery.description,
        ctaText: 'View Adventure',
      };
    },
  },
};
</script>

<style scoped>
.experience-shell {
  background: #050505;
  padding-bottom: 60px;
}

.back-link {
  border-color: #424242 !important;
  color: #fff !important;
}

.experience-intro {
  margin-bottom: 34px;
  max-width: 760px;
}

.kicker {
  color: #e23232;
  font-family: "Oswald", serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.experience-intro h1,
.empty-state h2,
.section-title {
  color: #fff;
  font-family: "Oswald", serif;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.1;
}

.experience-intro h1 {
  font-size: 2.6rem;
  margin: 12px 0 14px;
}

.experience-intro p,
.empty-state p {
  color: #c9c9c9;
  font-size: 1.15rem;
  line-height: 1.6;
  margin: 0 0 18px;
}

.section-title {
  border-top: 1px solid #2a2a2a;
  font-size: 2rem;
  margin: 0;
  padding-top: 30px;
}

.experience-grid {
  margin-top: 12px;
}

.empty-state {
  background: #0d0d0d;
  border: 1px solid #2a2a2a;
  border-radius: 8px;
  max-width: 680px;
  padding: 24px;
}

.empty-state h2 {
  font-size: 1.6rem;
  margin: 0 0 10px;
}
</style>
